import service from '@/utils/services'
import storage from '@/utils/localStorage'

const state = {
  choujiangVideo: {
    mobileBg: window.staticUrl+'office/assets/video/choujiang-bg.mp4',
    title: window.staticUrl+'office/assets/video/choujiang-title.mp4',
    renwu: window.staticUrl+'office/assets/video/choujiang-renwu.mp4'
  },
  reservationVideo: window.staticUrl+'office/assets/video/xzdzm_index.mp4',
  reservationPcVideo: window.staticUrl+'office/assets/video/xzdzm_pc_index1.mp4',
  videoUrl: window.staticUrl+'office/assets/video/xzdzm_video.mp4',
  rmjlVideo: window.staticUrl+'office/assets/video/xzdzm_rmjl_reservation.mp4',
  rmjlPcVideo: window.staticUrl+'office/assets/video/xzdzm_rmjl_pc_reservation.mp4',
  xmtsVideo: window.staticUrl+'office/assets/video/xzdzm_xmts_reservation.mp4',
  xmtsPcVideo: window.staticUrl+'office/assets/video/xzdzm_xmts_pc.mp4',
  shareUrl: 'https://xzdzm.zhuziplay.com/reservation',
  gameRolePid: 22,
  gameImgPid: 23,
  gameRolePcPid: 24,
  gameImgPcPid: 25,
  awards: [
    {id: 1, name: 'AirPods第三代', rate: '0.0001', ball: 'gold', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon1.png'},
    {id: 2, name: '乐高(LEGO)积木', rate: '0.0019', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon2.png'},
    {id: 3, name: '500元京东E卡', rate: '0.0030', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon3.png'},
    {id: 4, name: '100元京东E卡', rate: '0.0050', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon4.png'},
    {id: 5, name: '50元京东E卡', rate: '0.0100', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon5.png'},
    {id: 6, name: '仙宗大掌门鼠标垫', rate: '0.0100', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon6.png'},
    {id: 7, name: '渡劫礼包', rate: '0.0100', ball: 'red', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon7.png'},
    {id: 8, name: '问鼎礼包', rate: '0.0200', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon8.png'},
    {id: 9, name: '婴变礼包', rate: '0.0500', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon9.png'},
    {id: 10, name: '化神礼包', rate: '0.0800', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon10.png'},
    {id: 11, name: '元婴礼包', rate: '0.1000', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon11.png'},
    {id: 12, name: '结丹礼包', rate: '0.1200', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon12.png'},
    {id: 13, name: '筑基礼包', rate: '0.1500', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon13.png'},
    {id: 14, name: '炼气礼包', rate: '0.2000', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon14.png'},
    {id: 15, name: '金币*888', rate: '0.2400', ball: 'blue', gift: window.staticUrl+'office/xzdzm/reservation/jl-icon15.png'}
  ],
  user: {
    user_id: 0,// 1035846,
    token: '',// 'yjv3uw0gp3atd0criq3d2vbrhh900yoa'
  },
  invite_uid: 0,
  isAppStore: 0,
  isReservation: 0,
  reservation_mobile: '',
  appleUrl: 'https://apps.apple.com/cn/app/id6446186200'
}

const getters = {
  appleUrl: state => state. appleUrl,
  choujiangVideo: state => state.choujiangVideo,
  reservationVideo: state => state.reservationVideo,
  reservationPcVideo: state => state.reservationPcVideo,
  videoUrl: state => state.videoUrl,
  rmjlVideo: state => state.rmjlVideo,
  rmjlPcVideo: state => state.rmjlPcVideo,
  xmtsVideo: state => state.xmtsVideo,
  xmtsPcVideo: state => state.xmtsPcVideo,
  shareUrl: state => state.shareUrl,
  gameRolePid: state => state.gameRolePid,
  gameImgPid: state => state.gameImgPid,
  gameRolePcPid: state => state.gameRolePcPid,
  gameImgPcPid: state => state.gameImgPcPid,
  awards: state => state.awards,
  userInfo: (state) => {
    if (state.user.token === '') {
      let storageInfo = storage.get('obj_user')
      if (storageInfo !== null) {
        Object.assign(state.user, storageInfo)
      }
    }
    return state.user
  },
  isAppStore: (state) => {
    if (state.isAppStore === 0) {
      let storageInfo = storage.get('appstore')
      if (storageInfo !== null) {
        state.isAppStore = 1
      }
    }
    return state.isAppStore
  },
  inviteUid: (state) => {
    if (state.invite_uid === 0) {
      let storageInfo = storage.get('invite_uid')
      if (storageInfo !== null) {
        state.invite_uid = parseInt(storageInfo)
      }
    }
    return state.invite_uid
  },
  isReservation: (state) => {
    if (state.isReservation === 0) {
      let isReservation = storage.get('isReservation')
      if (isReservation !== null) {
        state.isReservation = 1
      }
    }
    return state.isReservation
  },
  reservationMobile: (state) => {
    if (state.reservation_mobile === '') {
      let reservationMobile = storage.get('reservation_mobile')
      if (reservationMobile !== null) {
        state.reservation_mobile = reservationMobile
      }
    }
    return state.reservation_mobile
  }
}

const mutations = {
  updateUser (state, params) {
    Object.assign(state.user, params)
    storage.set('obj_user', state.user)
  },
  updateAppStore (state, v) {
    state.isAppStore = v
    storage.set('appstore', v)
  },
  updateInviteUid (state, v) {
    state.invite_uid = v
    storage.set('invite_uid', v)
  },
  updateReservation (state, v) {
    state.isReservation = 1
    state.reservation_mobile = v
    storage.set('isReservation', 1)
    storage.set('reservation_mobile', v)
  },
}

const actions = {
  ActSetInvite ({ commit }, params) {
    commit('updateInviteUid', params.invite_uid)
  },
  ActAppStore ({ commit }) {
    commit('updateAppStore', 1)
  },
  ActReservation ({ commit }, params) {
    commit('updateReservation', params.mobile)
  },
  // 预约发送验证码
  ActCodeSend ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/code/cnAppoint', { act: true, mobile: params.mobile }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  //通过手机号码预约
  ActAppoint ({ commit, state, getters }, params) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/appoint', { act: true, mobile: params.mobile, code: params.code, device_type: params.os,  utm_source: params.utm_source, from_user_id: getters.inviteUid }).then((res) => {
        if (res.data.code === 0) {
          commit('updateUser', { user_id: res.data.data.user_id, token: res.data.data.token })
          resolve(res.data.data)
        } else if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  //获取预约总数接口
  ActAppointNum ({ commit, state }) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/appointNum', { act: true, token: state.user.token, user_id: state.user.user_id }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  //邀请数量接口
  ActInviteNum ({ commit, state }) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/inviteNum', { act: true, token: state.user.token, user_id: state.user.user_id }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  //抽奖
  ActLottery ({ commit, state }) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/lottery', { act: true, token: state.user.token, user_id: state.user.user_id }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 预约获奖记录
  ActCodeList ({ commit, state }) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/award', { act: true, token: state.user.token, user_id: state.user.user_id }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  //添加获奖领取地址
  ActSaveAddress ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      service.post('/xz/cn/saveAddress', { act: true, token: state.user.token, name: params.name, mobile: params.mobile, address: params.address }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
